import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconAlertTriangle,
  IconArrowBarToDown,
  IconArticle,
  IconDiscount,
  IconListLetters,
  IconShoppingBag,
  IconTransfer,
} from '@tabler/icons-react'

export const productIncomeModuleKey = 'product_income'
export const installPricesModuleKey = 'install_price'
export const inventoryModuleKey = 'inventory'
export const productTransferModuleKey = 'transfer'
export const productVariantModuleKey = 'product_variant'
export const discountModuleKey = 'discount'

const productIncomeRoute: RouteConfig = {
  uid: productIncomeModuleKey,
  path: 'products-actions/product-income',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/product-income'))
      .default,
  }),
}
const productIncomeRouteCreate: RouteConfig = {
  uid: productIncomeModuleKey,
  path: 'products-actions/product-income/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/product-income/create'))
      .default,
  }),
}
const productIncomeRouteEdit: RouteConfig = {
  uid: productIncomeModuleKey,
  path: 'products-actions/product-income/edit/:incomeId',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/product-income/edit'))
      .default,
  }),
}

const installPricesRoute: RouteConfig = {
  uid: installPricesModuleKey,
  path: 'products-actions/install-prices',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/install-prices'))
      .default,
  }),
}
const installPricesRouteCreate: RouteConfig = {
  uid: installPricesModuleKey,
  path: 'products-actions/install-prices/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/install-prices/create'))
      .default,
  }),
}
const installPricesEditRoute: RouteConfig = {
  uid: installPricesModuleKey,
  path: 'products-actions/install-prices/:id',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/install-prices/edit'))
      .default,
  }),
}
const installPricesViewRoute: RouteConfig = {
  uid: installPricesModuleKey,
  path: 'products-actions/install-prices/view/:id',
  type: 'list',

  lazy: async () => ({
    Component: (await import('@/pages/products-actions/install-prices/view'))
      .default,
  }),
}

const inventoryRoute: RouteConfig = {
  uid: inventoryModuleKey,
  path: 'products-actions/inventory',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/inventory')).default,
  }),
}
const createInventoryRoute: RouteConfig = {
  uid: inventoryModuleKey,
  path: 'products-actions/inventory/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/inventory/create'))
      .default,
  }),
}

const editInventoryRoute: RouteConfig = {
  uid: inventoryModuleKey,
  path: 'products-actions/inventory/edit/:inventoryId',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/inventory/edit'))
      .default,
  }),
}

const productTransferRoute: RouteConfig = {
  uid: productTransferModuleKey,
  path: 'products-actions/product-transfer',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/product-transfer'))
      .default,
  }),
}

const createproductTransferRoute: RouteConfig = {
  uid: productTransferModuleKey,
  path: 'products-actions/product-transfer/create',
  type: 'list',
  lazy: async () => ({
    Component: (
      await import('@/pages/products-actions/product-transfer/create')
    ).default,
  }),
}

const createTransferRequestRoute: RouteConfig = {
  uid: productTransferModuleKey,
  path: 'products-actions/product-transfer/create-request',
  type: 'create',
  lazy: async () => ({
    Component: (
      await import('@/pages/products-actions/product-transfer/create-request')
    ).default,
  }),
}

const editproductTransferRoute: RouteConfig = {
  uid: productTransferModuleKey,
  path: 'products-actions/product-transfer/:id',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/product-transfer/edit'))
      .default,
  }),
}

const productVariantRoute: RouteConfig = {
  uid: productVariantModuleKey,
  path: 'products-actions/product-variant',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/product-variant'))
      .default,
  }),
}

const discountRoute: RouteConfig = {
  uid: productVariantModuleKey,
  path: 'products-actions/discount',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/discount')).default,
  }),
}
const discountRouteCreate: RouteConfig = {
  uid: productVariantModuleKey,
  path: 'products-actions/discount/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/discount/create'))
      .default,
  }),
}
const discountEditRoute: RouteConfig = {
  uid: productVariantModuleKey,
  path: 'products-actions/discount/:id',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/products-actions/discount/edit')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Products Actions',
  href: 'products-actions',
  icon: <IconShoppingBag size={18} />,
  order: 2,
  sub: [
    {
      uid: productIncomeModuleKey,
      title: 'Product Income',
      href: 'products-actions/product-income',
      icon: <IconArrowBarToDown size={18} />,
      order: 1,
    },
    {
      uid: installPricesModuleKey,
      title: 'Install Prices',
      href: 'products-actions/install-prices',
      icon: <IconAlertTriangle size={18} />,
      order: 2,
    },
    {
      uid: inventoryModuleKey,
      title: 'Inventory',
      href: 'products-actions/inventory',
      icon: <IconArticle size={18} />,
      order: 3,
    },
    {
      uid: productTransferModuleKey,
      title: 'Product transfer',
      href: 'products-actions/product-transfer',
      icon: <IconTransfer size={18} />,
      order: 4,
    },
    {
      uid: productVariantModuleKey,
      title: 'Product variant',
      href: 'products-actions/product-variant',
      icon: <IconListLetters size={18} />,
      order: 5,
    },
    {
      uid: discountModuleKey,
      title: 'Discount',
      href: 'products-actions/discount',
      icon: <IconDiscount size={18} />,
      order: 6,
    },
  ],
}

export default [
  productIncomeRoute,
  productIncomeRouteCreate,
  productIncomeRouteEdit,
  installPricesRoute,
  installPricesRouteCreate,
  installPricesEditRoute,
  installPricesViewRoute,
  inventoryRoute,
  productTransferRoute,
  createproductTransferRoute,
  createTransferRequestRoute,
  editproductTransferRoute,
  createInventoryRoute,
  editInventoryRoute,
  productVariantRoute,
  discountRoute,
  discountRouteCreate,
  discountEditRoute,
]
